import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { getUserProjects } from "authoring/users/projects/controller/get-user-projects"
import { AuthoringHomeStatTile } from "../../authoring-home-stat-tile"

export function ArchivedWorkPackagesTile() {
    const result = getUserProjects.useResults({ archived: true }, withInitialValue(IS_LOADING))
    const count = result === IS_LOADING ? IS_LOADING : result?.total ?? 0

    return (
        <AuthoringHomeStatTile
            title="Archived Work Package"
            pluralTitle="Archived Work Packages"
            count={count}
            icon="material-symbols:archive-outline"
            palette="warning"
            to="/authoring/projects/archive"
        />
    )
}
